import { Omit, TextArea as BoldTextArea, TextAreaProps as BoldTextAreaProps } from 'bold-ui'
import { CypressProps } from 'types/cypress'

import { UseFieldProps, usePecField } from '../hooks'
import { getFieldError } from '../util'

export type TextAreaFieldProps = UseFieldProps & Omit<BoldTextAreaProps, 'name'> & CypressProps

export function TextAreaField({ dataTestId, ...restProps }: TextAreaFieldProps) {
  const { input, meta, ...rest } = usePecField(restProps)

  const error = getFieldError(meta) || undefined

  return <BoldTextArea error={error} data-testid={dataTestId} {...input} {...rest} />
}
